/**
 * 自動發送機制 API Service
 */

import apiClient from '../axios.js';

export const autoSendService = {
  /**
   * 查詢生日禮模組清單
   */
  async getBirthdayGiftModules() {
    const response = await apiClient.get('/admin/auto-send/birthday-gift/modules');
    return response;
  },

  /**
   * 新增生日禮模組
   */
  async createBirthdayGiftModule(data) {
    const response = await apiClient.post('/admin/auto-send/birthday-gift/modules', data);
    return response;
  },

  /**
   * 查詢單一生日禮模組設定
   */
  async getBirthdayGiftModule(moduleId) {
    const response = await apiClient.get(`/admin/auto-send/birthday-gift/modules/${moduleId}`);
    return response;
  },

  /**
   * 更新生日禮模組設定
   */
  async updateBirthdayGiftModule(moduleId, configData) {
    const response = await apiClient.put(`/admin/auto-send/birthday-gift/modules/${moduleId}`, configData);
    return response;
  },

  /**
   * 刪除生日禮模組
   */
  async deleteBirthdayGiftModule(moduleId) {
    const response = await apiClient.delete(`/admin/auto-send/birthday-gift/modules/${moduleId}`);
    return response;
  },

  /**
   * 查詢生日禮設定（相容舊 API，回傳第一個模組）
   */
  async getBirthdayGiftConfig() {
    // axios interceptor 已經返回 response.data，所以這裡直接返回 response
    const response = await apiClient.get('/admin/auto-send/birthday-gift/config');
    return response;
  },

  /**
   * 更新生日禮設定
   */
  async updateBirthdayGiftConfig(configData) {
    // axios interceptor 已經返回 response.data，所以這裡直接返回 response
    const response = await apiClient.put('/admin/auto-send/birthday-gift/config', configData);
    return response;
  },

  /**
   * 查詢生日禮發送日誌
   */
  async getBirthdayGiftLogs(params) {
    // axios interceptor 已經返回 response.data，所以這裡直接返回 response
    const response = await apiClient.get('/admin/auto-send/birthday-gift/logs', { params });
    return response;
  },

  /**
   * 手動補發生日禮
   */
  async manualSendBirthdayGift(data) {
    // axios interceptor 已經返回 response.data，所以這裡直接返回 response
    const response = await apiClient.post('/admin/auto-send/birthday-gift/manual-send', data);
    return response;
  },

  /**
   * 查詢週年禮模組清單
   */
  async getAnniversaryGiftModules() {
    const response = await apiClient.get('/admin/auto-send/anniversary-gift/modules');
    return response;
  },

  /**
   * 新增週年禮模組
   */
  async createAnniversaryGiftModule(data) {
    const response = await apiClient.post('/admin/auto-send/anniversary-gift/modules', data);
    return response;
  },

  /**
   * 查詢單一週年禮模組設定
   */
  async getAnniversaryGiftModule(moduleId) {
    const response = await apiClient.get(`/admin/auto-send/anniversary-gift/modules/${moduleId}`);
    return response;
  },

  /**
   * 更新週年禮模組設定
   */
  async updateAnniversaryGiftModule(moduleId, configData) {
    const response = await apiClient.put(`/admin/auto-send/anniversary-gift/modules/${moduleId}`, configData);
    return response;
  },

  /**
   * 刪除週年禮模組
   */
  async deleteAnniversaryGiftModule(moduleId) {
    const response = await apiClient.delete(`/admin/auto-send/anniversary-gift/modules/${moduleId}`);
    return response;
  },

  /**
   * 查詢週年禮發送日誌
   */
  async getAnniversaryGiftLogs(params) {
    const response = await apiClient.get('/admin/auto-send/anniversary-gift/logs', { params });
    return response;
  },

  /**
   * 手動補發週年禮（補發今年度）
   */
  async manualSendAnniversaryGift(data) {
    const response = await apiClient.post('/admin/auto-send/anniversary-gift/manual-send', data);
    return response;
  },

  /**
   * 查詢註冊禮活動清單
   */
  async getRegistrationGiftModules() {
    const response = await apiClient.get('/admin/auto-send/registration-gift/modules');
    return response;
  },

  /**
   * 新增註冊禮活動
   */
  async createRegistrationGiftModule(data) {
    const response = await apiClient.post('/admin/auto-send/registration-gift/modules', data);
    return response;
  },

  /**
   * 查詢單一註冊禮活動設定
   */
  async getRegistrationGiftModule(moduleId) {
    const response = await apiClient.get(`/admin/auto-send/registration-gift/modules/${moduleId}`);
    return response;
  },

  /**
   * 更新註冊禮活動設定
   */
  async updateRegistrationGiftModule(moduleId, configData) {
    const response = await apiClient.put(`/admin/auto-send/registration-gift/modules/${moduleId}`, configData);
    return response;
  },

  /**
   * 刪除註冊禮活動
   */
  async deleteRegistrationGiftModule(moduleId) {
    const response = await apiClient.delete(`/admin/auto-send/registration-gift/modules/${moduleId}`);
    return response;
  },

  /**
   * 查詢註冊禮發送日誌
   */
  async getRegistrationGiftLogs(params) {
    // axios interceptor 已經返回 response.data，所以這裡直接返回 response
    const response = await apiClient.get('/admin/auto-send/registration-gift/logs', { params });
    return response;
  },

  /**
   * 查詢升等禮設定
   */
  async getTierUpgradeGiftConfig() {
    // axios interceptor 已經返回 response.data，所以這裡直接返回 response
    const response = await apiClient.get('/admin/auto-send/tier-upgrade-gift/config');
    return response;
  },

  /**
   * 更新升等禮設定
   */
  async updateTierUpgradeGiftConfig(configData) {
    // axios interceptor 已經返回 response.data，所以這裡直接返回 response
    const response = await apiClient.put('/admin/auto-send/tier-upgrade-gift/config', configData);
    return response;
  },

  /**
   * 查詢升等禮發送日誌
   */
  async getTierUpgradeGiftLogs(params) {
    // axios interceptor 已經返回 response.data，所以這裡直接返回 response
    const response = await apiClient.get('/admin/auto-send/tier-upgrade-gift/logs', { params });
    return response;
  }
};
